import { FormSelectOption } from '@/modules/core/form/models/FormSelectOption';
import ClusterFormService from '@/modules/ta/cluster/services/ClusterFormService';

export class ClusterSelectOption extends FormSelectOption {
  constructor(config = {}) {
    super({
      placeholder: i18n.$t('Select a Business Unit'),
      ...config,
    });
  }

  /**
   * @param params
   * @returns {Promise<*>}
   */
  getData(params) {
    return ClusterFormService.getValues({ fields: 'name', ...params });
  }
}
